import React, { useState, useEffect, Fragment, useRef, useCallback } from "react";
import cx from "classnames";
import axios from "axios";
import moment from "moment";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import AuthService from "../../pages/Authentication/auth.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import PerfectScrollbar from "react-perfect-scrollbar";
import 'react-perfect-scrollbar/dist/css/styles.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDown, faUser, faUserEdit, faHistory } from "@fortawesome/free-solid-svg-icons";
import { IoIosNotifications } from "react-icons/io";
import Flag from "react-flagkit";
import city2 from "../../assets/utils/images/dropdown-header/city2.jpg";
import user from "../../assets/utils/images/avatars/user_gen.png";
import { useSelector } from 'react-redux';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import {
  DropdownToggle,
  DropdownMenu,
  Button,
  UncontrolledButtonDropdown,
  UncontrolledDropdown,
  DropdownItem,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import './Topbar.css';
import './Notifications.css';
import { subscribeToForegroundMessages, fetchFCMToken } from '../../firebase/messaging';
import AlertService from "../Alerts/alerts";
import { toast } from 'react-toastify';
import { io } from 'socket.io-client';
import clientPkg from '../../../package.json';

library.add(faUser, faUserEdit, faHistory);
const B_URL = process.env.REACT_APP_LOGINURL;

const Topbar = () => {
  const { t, i18n } = useTranslation();
  const authData = useSelector((state) => state.authReducer.authData);
  const navigate = useNavigate();
  const currentUser = authData?.userData;
  const [storeduser, setStoredUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [logo, setLogo] = useState(localStorage.getItem("system_logo"));
  const [langFlag, setlangFlag] = useState('');
  const [active1, setActive1] = useState(false);
  const [active2, setActive2] = useState(false);
  const [user_type, setUser_type] = useState(localStorage.getItem('user_type'));
  const [notifications, setNotifications] = useState([]);
  const [feVersion] = useState(process.env.REACT_APP_VERSION || clientPkg.version || '0.0.0');
  const [beVersion, setBeVersion] = useState(null);
  const [versionOk, setVersionOk] = useState(true);

  const dropdownRef = useRef(null); // Ref for the UncontrolledDropdown
  const socketRef = useRef(null);

  const fetchUnreadNotifications = useCallback(async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'token': authData?.sessionID || storeduser['session-id']
      };
      const payload = {
        functionName: "GetAdminOrdersList",
        postData: { user_id: currentUser?._id || storeduser['_id'] }
      };
      // Only admins should fetch the broadcast admin notifications.
      // Customers and doctors fetch their own user-scoped notifications.
      const url = user_type === 'admin'
        ? "NotificationModule/GetAdmin_UnreadNotification"
        : "NotificationModule/GetUnreadNotification";
      const response = await axios.post(`${B_URL}${url}`, payload, { headers });
      if (response.data.status) {
        setNotifications(response.data.data);
      } else {
        //iph todo: 47
        //console.log("Failed to fetch notifications");
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }, [authData?.sessionID, storeduser, currentUser?._id, user_type]);

  useEffect(() => {
    setLanguageFlag(localStorage.getItem("language"));
    fetchUnreadNotifications();
    // fetch backend version once and then on interval
    const loadBackendVersion = async () => {
      try {
        const res = await axios.get(`${B_URL}version`, { headers: { 'Cache-Control': 'no-store' } });
        const v = res?.data?.version || null;
        setBeVersion(v);
        setVersionOk(Boolean(v) && v === feVersion);
      } catch (e) {
        setBeVersion(null);
        setVersionOk(false);
      }
    };
    loadBackendVersion();
    const iv = setInterval(loadBackendVersion, 60000);
    
    // Check notification permissions and FCM setup
    (async () => {
      //iph todo: 47
      //console.log('Checking notification permissions...');
      if ('Notification' in window) {
        //iph todo: 47
        //console.log('Notification permission status:', Notification.permission);
        if (Notification.permission === 'default') {
          const permission = await Notification.requestPermission();
          //iph todo: 47
          //console.log('Notification permission requested:', permission);
        }
      }
      
      // Check if service worker is registered
      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js');
          //iph todo: 47
          //console.log('Service Worker registration:', registration);
          if (registration) {
            //iph todo: 47
            //console.log('Service Worker is active:', registration.active);
          } else {
            //iph todo: 47
            //console.log('Service Worker not found, registering...');
            await navigator.serviceWorker.register('/firebase-messaging-sw.js');
          }
        } catch (e) {
          console.error('Service Worker error:', e);
        }
      }
      
      // Check FCM token
      try {
        const fcmToken = await fetchFCMToken();
        //iph todo: 47
        //console.log('FCM Token:', fcmToken);
        if (!fcmToken) {
          //iph todo: 47
          //console.error('FCM Token is null - notifications will not work');
        }
      } catch (e) {
        console.error('FCM Token fetch error:', e);
      }
    })();
    
    let unsubscribe = () => {};
    (async () => {
      unsubscribe = await subscribeToForegroundMessages((payload) => {
        // Refresh unread list
        fetchUnreadNotifications();
        
        // Get title and body from data payload
        const title = payload?.data?.title || 'Notification';
        const body = payload?.data?.body || payload?.data?.message || '';
        
        // Show toast notification
        toast.success(`${title}${body ? ': ' + body : ''}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: 'custom-toast-success',
          bodyClassName: 'custom-toast-body',
          progressClassName: 'custom-toast-progress',
        });
        
        // Play notification sound
        try {
          const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIG2m98OScTgwOUarm7blmGgU7k9n1unEiBC13yO/eizEIHWq+8+OWT');
          audio.volume = 0.5;
          audio.play().catch(() => {});
        } catch (e) {
          // Silent fail for audio
        }
      });
    })();

    // Listen to background messages forwarded by SW
    const onSwMessage = (event) => {
      try {
        if (event?.data?.type === 'FCM_BACKGROUND_MESSAGE') {
          const payload = event.data.payload;

          // Treat like foreground
          fetchUnreadNotifications();
          const title = payload?.data?.title || payload?.notification?.title || 'Notification';
          const body = payload?.data?.body || payload?.notification?.body || payload?.data?.message || '';
          toast.success(`${title}${body ? ': ' + body : ''}`, {
            className: 'custom-toast-success',
            bodyClassName: 'custom-toast-body',
            progressClassName: 'custom-toast-progress',
          });
          try {
            const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIG2m98OScTgwOUarm7blmGgU7k9n1unEiBC13yO/eizEIHWq+8+OWT');
            audio.volume = 0.5; 
            audio.play().catch(() => {});
          } catch {}
        }
      } catch (e) {}
    };
    navigator.serviceWorker?.addEventListener('message', onSwMessage);
    // Socket.io realtime notifications
    // try {
    //   const s = io('/', { path: '/socket.io', transports: ['websocket'] });
    //   socketRef.current = s;
    //   const userId = currentUser?._id || storeduser?._id;
    //   if (userId) s.emit('join_user', { userId });
    //   if (user_type === 'admin') s.emit('join_admin');
    //   const handleRealtime = (payload) => {
    //     fetchUnreadNotifications();
    //     const title = 'Notification';
    //     const body = payload?.message || '';
    //     if (body) {
    //       toast.success(`${title}${body ? ': ' + body : ''}`, {
    //         className: 'custom-toast-success',
    //         bodyClassName: 'custom-toast-body',
    //         progressClassName: 'custom-toast-progress',
    //       });
    //     }
    //   };
    //   s.on('notification', handleRealtime);
    //   s.on('order_message', handleRealtime);
    // } catch (e) {}
    // return () => { 
    //   try { unsubscribe && unsubscribe(); } catch (e) {}
    //   try { navigator.serviceWorker?.removeEventListener('message', onSwMessage); } catch (e) {}
    //   try { socketRef.current?.disconnect(); } catch (e) {}
    //   try { clearInterval(iv); } catch (e) {}
    // };
  }, [fetchUnreadNotifications, feVersion]);

  function logOut() {
    if (user_type === 'users') {
      navigate("/user-login/doctors");
    } else if (user_type === 'customers') {
      navigate("/customer_login");
    } else {
      navigate("/login");
    }
    AuthService.logout();
    // window.location.reload();
  }

  function setLanguageFlag(lang) {
    if (lang === 'en') {
      setlangFlag('GB');
      setActive1(true);
      setActive2(false);
    } else {
      setlangFlag('MY');
      setActive1(false);
      setActive2(true);
    }
  }

  const markNotificationAsRead = async (notification) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'token': authData?.sessionID || storeduser['session-id']
      };
      await axios.put(`${B_URL}NotificationModule/MarkRead`, { _id: notification._id }, { headers });
      setNotifications((prev) => prev.filter((n) => n._id !== notification._id));
      if (notification.url) {
        window.open(notification.url);
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const markAsReadOnly = async (notification) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'token': authData?.sessionID || storeduser['session-id']
      };
      await axios.put(`${B_URL}NotificationModule/MarkRead`, { _id: notification._id }, { headers });
      setNotifications((prev) => prev.filter((n) => n._id !== notification._id));
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const goToNotificationHistory = () => {
    dropdownRef.current.toggle(); // Close the dropdown
    navigate("/notification_history");
  };




  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition
          component="div"
          className={cx("app-header header-shadow")}
          appear={true} timeout={1500} enter={false} exit={false}>
          <div className="topbar-container">
            <div className="app-header__logo">
              
              <img alt="BaseSystem" src={logo} className="app-logo" />
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: 8 }}>
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  padding: '2px 8px',
                  borderRadius: 12,
                  background: '#f5f7fb',
                  color: '#334155',
                  fontSize: 12,
                  fontWeight: 600,
                  border: '1px solid #e5e7eb'
                }} title={`Frontend ${feVersion}${beVersion ? ` | Backend ${beVersion}` : ''}`}>
                  <span style={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    background: versionOk ? '#22c55e' : '#f59e0b'
                  }} />
                  v{feVersion}{beVersion !== null ? ` · API v${beVersion}` : ' · API …'}
                </span>
              </div>
            </div>
            <div className="app-header__content">
              <div className="app-header-right">
                {/* Test buttons for debugging */}
                <div className="header-dots">
                  <UncontrolledDropdown ref={dropdownRef}>
                    <DropdownToggle onClick={fetchUnreadNotifications} className="p-0" color="link">
                      <div className="icon-wrapper icon-wrapper-alt rounded-circle" style={{ position: 'relative' }}>
                        <div className="icon-wrapper-bg bg-success" />
                        {/* Bell Icon with Notification Badge */}
                        <IoIosNotifications
                          color={notifications.length > 0 ? '#E53935' : "#3ac47d"}
                          fontSize="23px"
                        />
                        {notifications.length > 0 && (
                          <span
                            style={{
                              position: 'absolute',
                              top: '-5px',
                              right: '-5px',
                              backgroundColor: '#E53935', // Professional red for the badge
                              color: 'white',
                              fontSize: '10px',
                              fontWeight: 'bold',
                              borderRadius: '50%',
                              padding: '2px 5px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: '16px',
                              height: '16px',
                              boxShadow: '0 0 5px rgba(0,0,0,0.3)', // Subtle shadow for a professional look
                            }}
                          >
                            {notifications.length}
                          </span>
                        )}
                      </div>
                    </DropdownToggle>
                    <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                      <div className="dropdown-menu-header mb-0">
                        <div className="dropdown-menu-header-inner bg-strong-bliss">
                          <div className="menu-header-image opacity-1" style={{ backgroundImage: `url(${city2})` }} />
                          <div className="menu-header-content text-white">
                            <h5 className="menu-header-title">{t('Notifications')}</h5>
                            <h6 className="menu-header-subtitle">
                              {t('You have')} <b className="text-warning">{notifications.length}</b> {t('unread Notifications')}
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div className="scroll-area-sm">
                        <PerfectScrollbar>
                          <div className="p-4">
                            <TransitionGroup component={VerticalTimeline} layout="1-column">
                              {notifications.map((notification) => (
                                <CSSTransition
                                  key={notification._id}
                                  timeout={500}
                                  classNames="notification-item">
                                  <VerticalTimelineElement
                                    className="vertical-timeline-item"
                                    icon={<i className="badge badge-dot badge-dot-xl bg-success">{" "}</i>}
                                    date={moment(notification.createdAt).format('hh:mm A')}>
                                    <h4 className="timeline-title">{notification.message}</h4>
                                    <p>
                                      {notification.url && (
                                        <a onClick={() => markNotificationAsRead(notification)} style={{ cursor: 'pointer' }}>
                                          {t('View Details')}
                                        </a>
                                      )}
                                      <Button
                                        color="link"
                                        className="ms-2"
                                        onClick={() => markAsReadOnly(notification)}
                                        style={{ fontSize: '0.9rem', padding: '0' }}>
                                        {t('Mark as Read')}
                                      </Button>
                                    </p>
                                  </VerticalTimelineElement>
                                </CSSTransition>
                              ))}
                            </TransitionGroup>
                          </div>
                        </PerfectScrollbar>
                      </div>
                      <div className="notification-history-footer">
                        <Button color="primary" onClick={goToNotificationHistory} className="w-100">
                          <FontAwesomeIcon icon={faHistory} /> {t('View Notification History')}
                        </Button>
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>

                </div>
                <div className="header-btn-lg pe-0">
                  <UncontrolledButtonDropdown>
                    <DropdownToggle color="link" className="p-0">
                      <img width={28} src={user} alt="User" />
                      <FontAwesomeIcon className="ms-2 opacity-8" icon={faAngleDown} />
                    </DropdownToggle>
                    <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                      <div className="dropdown-menu-header">
                        <div className="dropdown-menu-header-inner bg-info">
                          <div className="menu-header-content text-start">
                            <div className="widget-content p-0">
                              <div className="widget-content-wrapper">
                                <div className="widget-content-left me-3">
                                  <img width={62} className="rounded-circle" src={user} alt="User Avatar" />
                                </div>
                                <div className="widget-content-left">
                                  {currentUser && <div className="widget-heading">{currentUser.name}</div>}
                                  <div className="widget-subheading opacity-8">{currentUser?.role_details?.name}</div>
                                </div>
                                <div className="widget-content-right me-2">
                                  <Button className="btn-pill btn-shadow btn-custom-color btn-shine" onClick={logOut}>
                                    {t('Logout')}
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <PerfectScrollbar>
                        <div className="scroll-area-xs" style={{ height: "80px" }}>
                          <Nav vertical>
                            <NavItem>
                              <NavLink href={user_type === 'users' ? "/doctor-profile" : user_type === 'customers' ? "/edit_profile" : "/my-profile"}>
                                <FontAwesomeIcon icon={faUserEdit} className="px-2 py-0" style={{ marginBottom: "3px" }} />
                                {t('My Profile')}
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>
                      </PerfectScrollbar>
                    </DropdownMenu>
                  </UncontrolledButtonDropdown>
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
};

export default Topbar;
